export default "__VITE_ASSET__DhErOsty__"